// transitRegisterEmailLogout.js
'use strict';
import logout from '../action/logout.js';
import addModal from '../action/addModal.js';
import removeModals from '../action/removeModals.js';
import updateRegisterData from '../action/updateRegisterData.js';
import getRegisterData from '../selector/getRegisterData.js';
import { register as registerModal } from '../resource/modalId.js';

/**
 * Transit register email logout
 * @kind action
 * @param {string} {action} - action param. ['coming', 'goback', 'logout']
 * @return {Promise} Action promise.
 */
const transitRegisterEmailLogout =
  ({ action }) =>
  async (dispatch, getState) => {
    switch (action) {
      case 'coming': {
        dispatch(
          addModal({
            id: registerModal.REGISTER_EMAIL_LOGOUT,
            transitionStatus: 'coming',
            isHigherThanAll: true,
          })
        );
        return dispatch(
          removeModals({
            ids: [registerModal.EMAIL_VERIFY],
            transitionStatus: 'closing',
          })
        );
      }
      case 'goback': {
        const isFromBindAccount = getRegisterData(
          getState(),
          'isFromBindAccount'
        );
        if (isFromBindAccount) {
          dispatch(
            updateRegisterData({
              dataKey: 'isFromBindAccount',
              value: false,
            })
          );
          return dispatch(
            removeModals({
              ids: [registerModal.REGISTER_EMAIL_LOGOUT],
              transitionStatus: 'reversing',
            })
          );
        }
        dispatch(
          addModal({
            id: registerModal.REGISTER_EMAIL,
            transitionStatus: 'backing',
            isHigherThanAll: true,
          })
        );
        return dispatch(
          removeModals({
            ids: [registerModal.REGISTER_EMAIL_LOGOUT],
            transitionStatus: 'reversing',
          })
        );
      }
      case 'logout': {
        setTimeout(
          () =>
            dispatch(logout({ via: 'register', pathname: location.pathname })),
          600 // TODO: remote config
        );
        return dispatch(
          removeModals({
            ids: [registerModal.REGISTER_EMAIL_LOGOUT],
            transitionStatus: 'leaving',
          })
        );
      }
      default:
        return { type: '' };
    }
  };

export default transitRegisterEmailLogout;
